import { Link } from '@inertiajs/react';
import { ReactNode } from 'react';

import { useLocale } from '../../Shared/locale';
import { Event } from '../../Shared/types';
import { PickerItem } from '../../Shared/UI/Picker';
import Layout from '../UI/Layout';

export interface ConnectedCharitiesSectionProps {
  charities: (PickerItem & { logo_url: string | null; slug: string; })[];
  event?: Event | null;
  destination?: 'overview' | 'create';
}

export default function ConnectedCharitiesSection({
  charities,
  event,
  destination,
}: ConnectedCharitiesSectionProps) {
  const { locale } = useLocale();

  const prefix = destination === 'create' ? '/create' : `/${locale}/fundraisers`;

  const getUrl = (charity: { slug: string; }) => {
    if (event) {
      return `${prefix}/${charity.slug}/${event.slug}`;
    }

    return `${prefix}/${charity.slug}`;
  };

  return (
    <div className="grid grid-cols-5 md:grid-cols-10 gap-2 sm:gap-4">
      {charities.filter((charity) => charity.logo_url).slice(0, 10).map((charity) => (
        <Link
          href={getUrl(charity)}
          className="flex items-center justify-center p-3 sm:py-6 aspect-square shadow-[0_5px_15px_-3px_rgb(0_0_0_/_0.03),_0_4px_6px_-4px_rgb(0_0_0_/_0.05)] rounded-xl bg-white"
          key={charity.id}
        >
          <img src={charity.logo_url || ''} alt={charity.title} className="object-contain w-full h-full" />
        </Link>
      ))}
    </div>
  );
}

ConnectedCharitiesSection.layout = (page: ReactNode) => <Layout>{page}</Layout>;
